// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-contacts-container {
  min-height: 91.4vh;
  padding: 30px 140px;
  background-color: #F9FAFC;
  animation: fadeIn 1s;
}
.all-contacts-container .header {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 35px;
  margin: 0;
}
.all-contacts-container .filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.all-contacts-container .empty {
  display: flex;
  margin-top: 80px;
}
.all-contacts-container .empty > p {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 18px;
  justify-content: center;
  color: var(--secondary-color-5);
}
.all-contacts-container .item-container .header-container {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.all-contacts-container .item-container .header-container > p {
  margin: 0;
}
.all-contacts-container .item-container .header-container .header {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
}
.all-contacts-container .item-container .header-container .view {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: var(--primary-color-1);
  cursor: pointer;
}
.all-contacts-container .item-container .header-container .view:hover {
  opacity: 0.75;
}
.all-contacts-container .item-container .items {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -20px;
}
.all-contacts-container .item-container .items > div {
  font-size: 12px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  margin: 0 20px;
  margin-bottom: 30px;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 25px;
  height: 110px;
  width: 500px;
}
.all-contacts-container .item-container .items > div .details {
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.all-contacts-container .item-container .items > div .details > div {
  display: flex;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
}
.all-contacts-container .item-container .items > div .details > div.icons {
  position: absolute;
  right: 20px;
  top: 15px;
}
.all-contacts-container .item-container .items > div .details > div img {
  border: 3px solid #F4F5F6;
  border-radius: 10px;
  width: 70px;
  height: 70px;
  object-fit: cover;
}
.all-contacts-container .item-container .items > div .details > div .set {
  cursor: pointer;
  color: var(--secondary-color-5);
  font-weight: 700;
  transition: 0.3s ease-in-out;
}
.all-contacts-container .item-container .items > div .details > div .set:hover {
  color: var(--primary-color-1);
}
.all-contacts-container .item-container .items > div .details > div .current {
  color: var(--primary-color-1);
  font-weight: 700;
}
.all-contacts-container .item-container .items > div .details > div .info {
  margin-left: 25px;
}
.all-contacts-container .item-container .items > div .details > div .info > p {
  margin: 0;
}
.all-contacts-container .item-container .items > div .details > div .info .name {
  font-weight: 700;
  font-size: 20px;
  color: var(--secondary-color-1);
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.all-contacts-container .item-container .items > div .details > div .info .name:hover {
  color: var(--primary-color-1);
}
.all-contacts-container .item-container .items > div .details > div .info .email {
  font-weight: 600;
  font-size: 14px;
  color: #6C767C;
}
.all-contacts-container .item-container .items > div .details .compensation {
  display: flex;
  position: absolute;
  right: 20px;
  top: 15px;
  font-size: 14px;
  align-items: center;
}
.all-contacts-container .item-container .items > div .details .compensation > span {
  color: var(--primary-color-1);
  font-weight: 700;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/BuyerContacts/modules/AllContacts/allContacts.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AACJ;AAAI;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAER;AAAI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAER;AAAI;EACI,aAAA;EACA,gBAAA;AAER;AADQ;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,+BAAA;AAGZ;AACQ;EACI,uCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACZ;AAAY;EAAM,SAAA;AAGlB;AAFY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AAIhB;AAFY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AAIhB;AAHgB;EAAU,aAAA;AAM1B;AAHQ;EACI,aAAA;EACA,eAAA;EACA,eAAA;AAKZ;AAJY;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAMhB;AALgB;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAOpB;AANoB;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;AAQxB;AAPwB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAS5B;AAPwB;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAS5B;AAPwB;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,4BAAA;AAS5B;AAR4B;EACI,6BAAA;AAUhC;AAPwB;EACI,6BAAA;EACA,gBAAA;AAS5B;AAPwB;EACI,iBAAA;AAS5B;AAR4B;EAAM,SAAA;AAWlC;AAV4B;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,4BAAA;AAYhC;AAXgC;EACI,6BAAA;AAapC;AAV4B;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAYhC;AARoB;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAUxB;AATwB;EACI,6BAAA;EACA,gBAAA;AAW5B;AAJI;EACI;IAAK,UAAA;EAOX;EANM;IAAO,UAAA;EASb;AACF","sourcesContent":[".all-contacts-container {\r\n    min-height: 91.4vh;\r\n    padding: 30px 140px;\r\n    background-color: #F9FAFC;\r\n    animation: fadeIn 1s;\r\n    .header {\r\n        font-family: 'Proxima Nova', sans-serif;\r\n        font-weight: 700;\r\n        font-size: 35px;\r\n        margin: 0;\r\n    }\r\n    .filters {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .empty {\r\n        display: flex;\r\n        margin-top: 80px;\r\n        > p {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            font-size: 18px;\r\n            justify-content: center;\r\n            color: var(--secondary-color-5);\r\n        }\r\n    }\r\n    .item-container {\r\n        .header-container {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            > p { margin: 0; }\r\n            .header {\r\n                font-weight: 700;\r\n                font-size: 20px;\r\n                line-height: 24px;\r\n            }\r\n            .view {\r\n                font-weight: 700;\r\n                font-size: 16px;\r\n                line-height: 19px;\r\n                color: var(--primary-color-1);\r\n                cursor: pointer;\r\n                &:hover { opacity: .75; }\r\n            }\r\n        }\r\n        .items {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            margin: 0 -20px;\r\n            > div {\r\n                font-size: 12px;\r\n                font-weight: 500;\r\n                font-family: 'Roboto', sans-serif;\r\n                margin: 0 20px;\r\n                margin-bottom: 30px;\r\n                background: #FFFFFF;\r\n                box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\r\n                border-radius: 25px;\r\n                height: 110px;\r\n                width: 500px;\r\n                .details {\r\n                    display: flex;\r\n                    padding: 20px;\r\n                    align-items: center;\r\n                    justify-content: space-between;\r\n                    position: relative;\r\n                    > div {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        &.icons {\r\n                            position: absolute;\r\n                            right: 20px;\r\n                            top: 15px;\r\n                        }\r\n                        img {\r\n                            border: 3px solid #F4F5F6;\r\n                            border-radius: 10px;\r\n                            width: 70px;\r\n                            height: 70px;\r\n                            object-fit: cover;\r\n                        }\r\n                        .set {\r\n                            cursor: pointer;\r\n                            color: var(--secondary-color-5);\r\n                            font-weight: 700;\r\n                            transition: .3s ease-in-out;\r\n                            &:hover {\r\n                                color: var(--primary-color-1);\r\n                            }\r\n                        }\r\n                        .current {\r\n                            color: var(--primary-color-1);\r\n                            font-weight: 700;\r\n                        }\r\n                        .info {\r\n                            margin-left: 25px;\r\n                            > p { margin: 0; }\r\n                            .name {\r\n                                font-weight: 700;\r\n                                font-size: 20px;\r\n                                color: var(--secondary-color-1);\r\n                                cursor: pointer;\r\n                                transition: .3s ease-in-out;\r\n                                &:hover {\r\n                                    color: var(--primary-color-1);\r\n                                }\r\n                            }\r\n                            .email {\r\n                                font-weight: 600;\r\n                                font-size: 14px;\r\n                                color: #6C767C;\r\n                            }\r\n                        }\r\n                    }\r\n                    .compensation {\r\n                        display: flex;\r\n                        position: absolute;\r\n                        right: 20px;\r\n                        top: 15px;\r\n                        font-size: 14px;\r\n                        align-items: center;\r\n                        > span {\r\n                            color: var(--primary-color-1);\r\n                            font-weight: 700;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
